import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
    return (
        <div style={styles.container}>
            <div style={styles.content}>
                <h1 style={styles.title}>Privacy Policy</h1>
                <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>Big Rig USA Privacy Policy</h2>
                    <p style={styles.text}>
                        The Privacy Policy outlined below discloses the specific ways in which Big Rig USA functions, how you should use it or can use it, how we collect user information and how that information is handled and protected. Your privacy is important to Big Rig USA, and we're committed to making sure it is protected. We use your information only in the ways described below.
                    </p>
                    <p style={styles.text}>
                        By using this website you consent to this Policy, including your consent to our use and disclosure of information about you in the manner described in this Policy.
                    </p>
                </div>

                <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>Information Collection and Use</h2>
                    <p style={styles.text}>
                        Big Rig USA receives but does not track, a variety of "personally identifiable information," including your email address, IP address, and message content. When we need to collect personally identifiable information from you to execute a requested transaction or provide you with a particular service, we will ask you to voluntarily supply us with the information we need. We may ask you for information such as, but not limited to: your name, address, telephone number, and email address to process your submission.
                    </p>
                    <p style={styles.text}>
                        Big Rig USA does not collect your email address unless you actively provide it to the company so that we can communicate with you.
                    </p>
                </div>

                <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>IP Address Usage</h2>
                    <p style={styles.text}>
                        Your IP address may be used for various purposes, including:
                    </p>
                    <ul style={styles.list}>
                        <li>To diagnose service or technology problems reported by you that are associated with your IP address</li>
                        <li>To estimate the total number of users visiting the Site from specific locales, countries or regions of the world</li>
                    </ul>
                </div>

                <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>Data Security</h2>
                    <p style={styles.text}>
                        We maintain physical, electronic and procedural safeguards, in accordance with applicable state and federal standards, to protect your personal financial information against risks such as loss, destruction or misuse. These measures include computer safeguards, secured files and buildings, and restrictions on who may access your personal information.
                    </p>
                </div>

                <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>Cookies</h2>
                    <p style={styles.text}>
                        A cookie is a small amount of data, which often includes a unique identifier that is sent to your browser from a website's computers and then stored on your computer's hard drive. You can normally refuse cookies by setting preferences in your browser. You do not need to accept cookies in order to use the Big Rig USA service.
                    </p>
                </div>

                <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>Protecting Children's Privacy</h2>
                    <p style={styles.text}>
                        We do not knowingly collect personally identifiable information online from children under the age of 13. If a child under the age of 13 has provided us with personally identifiable information online, we ask that a parent or guardian contact us at lawsuitfortruckaccident.com or call (888) 202-1350.
                    </p>
                </div>

                <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>Contact Us</h2>
                    <p style={styles.text}>
                        If you have any questions about this Privacy Policy, please contact us at lawsuitfortruckaccident.com
                    </p>
                </div>

                <Link to="/" style={styles.backLink}>
                    ← Back to Home
                </Link>
            </div>
        </div>
    );
};

const styles = {
    container: {
        minHeight: '100vh',
        backgroundColor: '#f8f5ee',
        padding: '40px 20px',
        fontFamily: 'Poppins, sans-serif',
    },
    content: {
        maxWidth: '800px',
        margin: '0 auto',
        backgroundColor: 'white',
        padding: '40px',
        borderRadius: '10px',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
        textAlign: 'left',
    },
    title: {
        fontSize: '2.5rem',
        color: '#000000',
        marginBottom: '30px',
        textAlign: 'left',
    },
    section: {
        marginBottom: '30px',
        textAlign: 'left',
    },
    sectionTitle: {
        fontSize: '1.5rem',
        color: '#000000',
        marginBottom: '15px',
        textAlign: 'left',
    },
    text: {
        fontSize: '1rem',
        lineHeight: '1.6',
        color: '#333',
        marginBottom: '15px',
        textAlign: 'left',
    },
    list: {
        paddingLeft: '20px',
        marginBottom: '15px',
        textAlign: 'left',
    },
    backLink: {
        display: 'inline-block',
        marginTop: '30px',
        color: '#000000',
        textDecoration: 'none',
        fontSize: '1rem',
        fontWeight: '500',
        transition: 'color 0.3s ease',
        textAlign: 'left',
    },
};

export default PrivacyPolicy; 